module.exports = __webpack_public_path__ + "static/media/ram-charam.e12e1b02.png";